import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiAdminV1AccountsList: build.query<
      ApiAdminV1AccountsListApiResponse,
      ApiAdminV1AccountsListApiArg
    >({
      query: (queryArg) => ({ url: `/api/admin/v1/accounts/` }),
    }),
    apiAdminV1AccountsCreate: build.mutation<
      ApiAdminV1AccountsCreateApiResponse,
      ApiAdminV1AccountsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/accounts/`,
        method: "POST",
        body: queryArg.accountCreateUpdate,
      }),
    }),
    apiAdminV1AccountsPartialUpdate: build.mutation<
      ApiAdminV1AccountsPartialUpdateApiResponse,
      ApiAdminV1AccountsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/accounts/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedAccountCreateUpdate,
      }),
    }),
    apiAdminV1AccountsToggleStatusCreate: build.mutation<
      ApiAdminV1AccountsToggleStatusCreateApiResponse,
      ApiAdminV1AccountsToggleStatusCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/accounts/${queryArg.id}/toggle-status/`,
        method: "POST",
      }),
    }),
    apiAdminV1AccountsAddToOrganizationCreate: build.mutation<
      ApiAdminV1AccountsAddToOrganizationCreateApiResponse,
      ApiAdminV1AccountsAddToOrganizationCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/accounts/add_to_organization/`,
        method: "POST",
        body: queryArg.addAccountToOrganization,
      }),
    }),
    apiAdminV1AccountsDeleteAllCognitoUsersCreate: build.mutation<
      ApiAdminV1AccountsDeleteAllCognitoUsersCreateApiResponse,
      ApiAdminV1AccountsDeleteAllCognitoUsersCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/accounts/delete_all_cognito_users/`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as adminApi };
export type ApiAdminV1AccountsListApiResponse =
  /** status 200  */ AccountRead[];
export type ApiAdminV1AccountsListApiArg = {
  /** Account ID */
  id: number;
};
export type ApiAdminV1AccountsCreateApiResponse = /** status 201  */ object;
export type ApiAdminV1AccountsCreateApiArg = {
  /** Account ID */
  id: number;
  accountCreateUpdate: AccountCreateUpdate;
};
export type ApiAdminV1AccountsPartialUpdateApiResponse =
  /** status 200  */ object;
export type ApiAdminV1AccountsPartialUpdateApiArg = {
  /** Account ID */
  id: number;
  /** Account ID */
  pk: number;
  patchedAccountCreateUpdate: PatchedAccountCreateUpdate;
};
export type ApiAdminV1AccountsToggleStatusCreateApiResponse =
  /** status 200  */ object;
export type ApiAdminV1AccountsToggleStatusCreateApiArg = {
  /** Account ID */
  id: number;
  /** Account ID */
  pk: number;
};
export type ApiAdminV1AccountsAddToOrganizationCreateApiResponse =
  /** status 200  */ object;
export type ApiAdminV1AccountsAddToOrganizationCreateApiArg = {
  /** Account ID */
  id: number;
  addAccountToOrganization: AddAccountToOrganization;
};
export type ApiAdminV1AccountsDeleteAllCognitoUsersCreateApiResponse =
  /** status 200  */ object;
export type ApiAdminV1AccountsDeleteAllCognitoUsersCreateApiArg = {
  /** Account ID */
  id: number;
};
export type RoleEnum = 1 | 2 | 3 | 4;
export type Account = {
  email: string;
  first_name: string;
  last_name?: string | null;
  email_confirmed?: boolean;
  resend_conf?: number;
  last_login?: string | null;
  cognito_id?: string | null;
  role?: RoleEnum;
  guided_experience_state?: any | null;
};
export type AccountRead = {
  id: number;
  email: string;
  first_name: string;
  last_name?: string | null;
  is_active: string;
  status: string;
  email_confirmed?: boolean;
  resend_conf?: number;
  last_login?: string | null;
  cognito_id?: string | null;
  role?: RoleEnum;
  guided_experience_state?: any | null;
};
export type AccountCreateUpdateAccountTypeEnum = 4 | 3 | 2 | 1;
export type AccountCreateUpdate = {
  first_name: string;
  last_name: string;
  email: string;
  account_type: AccountCreateUpdateAccountTypeEnum;
};
export type PatchedAccountCreateUpdate = {
  first_name?: string;
  last_name?: string;
  email?: string;
  account_type?: AccountCreateUpdateAccountTypeEnum;
};
export type AddAccountToOrganization = {
  account_id: number;
  organization_id: number;
  first_name?: string;
  last_name?: string;
  email?: string;
};
export const {
  useApiAdminV1AccountsListQuery,
  useApiAdminV1AccountsCreateMutation,
  useApiAdminV1AccountsPartialUpdateMutation,
  useApiAdminV1AccountsToggleStatusCreateMutation,
  useApiAdminV1AccountsAddToOrganizationCreateMutation,
  useApiAdminV1AccountsDeleteAllCognitoUsersCreateMutation,
} = injectedRtkApi;
